<div class="user-management" *ngIf="selectedGroup">
  <div class="grid">
    <div class="col-12">
      <p-table id="userManagement" #pdt_user_management (onRowSelect)="handleUserSelection($event.data)" [alwaysShowPaginator]="false"
               [columns]="userColumns" [paginatorPosition]="'top'" [paginator]="true" [rows]="pageRows"
               [metaKeySelection]="false" [selection]="selectedUser" [filterDelay]="1"
               [value]="userList" selectionMode="single" [rowHover]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
              {{ col.header }}
            </th>
          </tr>
          <tr>
            <th *ngFor="let col of columns">
             <!-- <p-columnFilter type="text" [field]="col.field"></p-columnFilter>-->
              <p-columnFilter field="{{col.field}}" matchMode="contains" [showMenu]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <input type="text"
                         pInputText
                         [ngModel]="value"
                         (ngModelChange)="filter($event)"
                         class="p-inputtext"
                         placeholder="">
                </ng-template>
              </p-columnFilter>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-group let-columns="columns">
          <tr [pSelectableRow]="group">
            <td *ngFor="let column of columns">
              {{ group[ column.field ] }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'FOLDS.LIST_COMPONENT.EMPTY_MESSAGE' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="col-12">
      <button pButton type="button" [label]="'GROUP_MANAGEMENT.COMPONENT.CREATE_USER' | translate"
              [icon]="'fa fa-plus'" class="p-button-warning"
              (click)="createNewUser()"></button>
    </div>
    <div class="col-6">
      <div *ngIf="selectedUser">
        <div *ngIf="!editUser">
          <div class="grid">
            <p-fieldset [legend]="'GROUP_MANAGEMENT.COMPONENT.USER_DETAILS_HEADER' | translate">
              <div class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_DI_LABEL' | translate}}</div>
                <div class="col-7">{{selectedUser.sUserID}}</div>
              </div>
              <div class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_FIRST_NAME_LABEL' | translate}}</div>
                <div class="col-7">{{selectedUser.sUserFirstName}}</div>
              </div>
              <div class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_LAST_NAME_LABEL' | translate}}</div>
                <div class="col-7">{{selectedUser.sUserLastName}}</div>
              </div>
              <div class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_EMAIL_LABEL' | translate}}</div>
                <div class="col-7">{{selectedUser.sUserEmail}}</div>
              </div>
              <div class="col-12">
                <div class="col-5">{{'COMMON.LANGUAGES.LANGUAGE' | translate}}</div>
                <div class="col-7">{{languages[selectedUser.sLangID]}}</div>
              </div>
              <div  *ngIf="selectedUser.bAdmin || selectedUser.bSupervisor" class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_PERMISSION_LABEL' | translate}}</div>

                <div class="col-7 flex flex-column">
                  <div class="col-12">
                    <p-checkbox [disabled]="true" [label]="'GROUP_MANAGEMENT.COMPONENT.ADMINUSER_LABEL' | translate" [(ngModel)]="selectedUser.adminUsers" [binary]="true"></p-checkbox>
                  </div>
                  <div class="col-12">
                    <p-checkbox [disabled]="true" [label]="'GROUP_MANAGEMENT.COMPONENT.ADMINEXPRESS_LABEL' | translate" [(ngModel)]="selectedUser.adminExpress" [binary]="true"></p-checkbox>
                  </div>
                  <div class="col-12">
                    <p-checkbox [disabled]="true" [label]="'GROUP_MANAGEMENT.COMPONENT.GESTIONJOURNALISATION_LABEL' | translate" [(ngModel)]="selectedUser.adminLog" [binary]="true"></p-checkbox>
                  </div>
                  <div class="col-12">
                    <p-checkbox *ngIf="selectedUser.adminExpress" [disabled]="true" [label]="'GROUP_MANAGEMENT.COMPONENT.ADMINERL_LABEL' | translate" [(ngModel)]="selectedUser.adminErl" [binary]="true"></p-checkbox>
                  </div>
                  <div class="col-12">
                    <p-checkbox *ngIf="selectedUser.adminExpress" [disabled]="true" [label]="'GROUP_MANAGEMENT.COMPONENT.ADMINEMAIL_LABEL' | translate" [(ngModel)]="selectedUser.adminEmail" [binary]="true"></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-12 align-right">
                <button pButton type="button" [label]="'COMMON.EDIT' | translate"
                        [icon]="'fa fa-pencil'" class="p-button-warning"
                        (click)="editSelectedUser()"></button>
              </div>
            </p-fieldset>
          </div>
        </div>
        <div *ngIf="editUser">
          <div class="grid">
            <p-fieldset [legend]="'GROUP_MANAGEMENT.COMPONENT.USER_DETAILS_HEADER' | translate">
              <div class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_DI_LABEL' | translate}}</div>
                <div class="col-7" *ngIf="!newUser">{{editUser.sUserID}}</div>
                <div class="col-7" *ngIf="newUser"><input #sUserID pInputText [(ngModel)]="editUser.sUserID"></div>
              </div>
              <div class="col-12" *ngIf="duplicateId">
                <div class="col-5"></div>
                <div class="col-7 ">
                  <div class="error">{{duplicateIdLabel}}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="col-5">{{'COMMON.TITLES.LABEL' | translate}}</div>
                <div class="col-7">
                  <p-dropdown [options]="titles" #title [(ngModel)]="editUser.title" [style]="{'width':'150px'}">
                  </p-dropdown>
                </div>
              </div>
<!--              <div class="col-12">
                <div class="col-5">{{'LOGIN_COMPONENT.LABEL_PASSWORD' | translate}}</div>
                <div class="col-7"><input pInputText #sUserPwd [(ngModel)]="editUser.sUserPwd"></div>
              </div>-->
              <div class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_FIRST_NAME_LABEL' | translate}}</div>
                <div class="col-7"><input pInputText #sUserFirstName [(ngModel)]="editUser.sUserFirstName"></div>
              </div>
              <div class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_LAST_NAME_LABEL' | translate}}</div>
                <div class="col-7"><input pInputText #sUserLastName [(ngModel)]="editUser.sUserLastName"></div>
              </div>
              <div class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_EMAIL_LABEL' | translate}}</div>
                <div class="col-7"><input pInputText #sUserEmail [(ngModel)]="editUser.sUserEmail"></div>
              </div>
              <div class="col-12">
                <div class="col-5">{{'COMMON.LANGUAGES.LANGUAGE' | translate}}</div>
                <div class="col-7">
                  <p-dropdown [options]="locales" #sLangId [(ngModel)]="editUser.sLangID" [style]="{'width':'150px'}">
                  </p-dropdown>
                </div>
              </div>
              <div *ngIf="editUser.title !== 'utilisateur'" class="col-12">
                <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.USER_PERMISSION_LABEL' | translate}}</div>
                <div class="col-7 flex flex-column">
                  <div class="col-12">
                    <p-checkbox [label]="'GROUP_MANAGEMENT.COMPONENT.ADMINUSER_LABEL' | translate" [(ngModel)]="editUser.adminUsers" [binary]="true"></p-checkbox>
                  </div>
                  <div class="col-12">
                    <p-checkbox [label]="'GROUP_MANAGEMENT.COMPONENT.ADMINEXPRESS_LABEL' | translate" [(ngModel)]="editUser.adminExpress" [binary]="true" (ngModelChange)="onAdminExpressChange($event)"></p-checkbox>
                  </div>
                  <div class="col-12">
                    <p-checkbox [label]="'GROUP_MANAGEMENT.COMPONENT.GESTIONJOURNALISATION_LABEL' | translate" [(ngModel)]="editUser.adminLog" [binary]="true"></p-checkbox>
                  </div>
                  <div class="col-12">
                    <p-checkbox *ngIf="selectedUser.adminExpress" [label]="'GROUP_MANAGEMENT.COMPONENT.ADMINERL_LABEL' | translate" [(ngModel)]="editUser.adminErl" [binary]="true"></p-checkbox>
                  </div>
                  <div class="col-12">
                    <p-checkbox *ngIf="selectedUser.adminExpress" [label]="'GROUP_MANAGEMENT.COMPONENT.ADMINEMAIL_LABEL' | translate" [(ngModel)]="editUser.adminEmail" [binary]="true"></p-checkbox>
                  </div>
                </div>
              </div>

              <div class="col-12 align-right">
                <div class="col-4 align-left">
                  <button pButton type="button" [label]="'COMMON.CANCEL' | translate"
                          [icon]="'fa fa-times'" class="p-button-warning"
                          (click)="cancelEditUser()"></button>
                </div>
                <div class="col-4"></div>
                <div class="col-4 align-right">
                  <button pButton type="button" [label]="'COMMON.SAVE' | translate"
                          [icon]="'fa fa-save'" class="p-button-warning"
                          (click)="saveUser()"></button>
                </div>
              </div>
              <div class="col-12 error" *ngIf="errorMessage" >
                <p>{{errorMessage}}</p>
              </div>
            </p-fieldset>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
